export const byCreatedOn = (a, b) => new Date(b.created_on) - new Date(a.created_on)



// WEBPACK FOOTER //
// ./src/sorters.js